import { Component, DestroyRef, OnInit, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {TitleServiceService} from '../../services/title-service.service';
import {ArticlesService} from '../../services/articles.service';
import {TitleFormComponent} from '../forms/title-form/title-form.component';
import {ModalService} from '../modal/modal.service';
import {EditingService} from '../../services/editing.service';


@Component({
    selector: 'app-page-title',
    templateUrl: './page-title.component.html',
    styleUrls: ['./page-title.component.scss'],
    imports: []
})
export class PageTitleComponent implements OnInit {
  private editService = inject(EditingService);
  private modal = inject(ModalService);
  private articleService = inject(ArticlesService);
  private destroyRef = inject(DestroyRef);

  readonly type = input.required<any>();
  readonly editMode = this.editService.editMode;

  titleContent;

  ngOnInit() {
    this.getTitle();
  }

  onEditTitle() {
    const titleForm = this.titleContent ? this.titleContent : null;
    const titleId = this.titleContent ? this.titleContent.id : null;

    this.modal.open(TitleFormComponent,
        {data:
                {title: 'Edit page title', content: titleForm, page: this.type(), id: titleId  }})
        .afterClosed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe( response => {
      this.articleService.saveTitle(response);
    });
    this.getTitle();
  }

  getTitle() {
    this.articleService.getTitle().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
      const filteredTitle = data.filter((title) => title.attributes.page === this.type());
      this.titleContent = filteredTitle[0];
    });
  }
}
